<template>
    <div style="text-align: center">
        <h2>บันทึกเครดิต</h2>
        <div class="row">
            <div class="col-4 text-right">เซลล์</div>
            <div class="col-6">
                <input class="form-control" v-model="form.sale.name" disabled/>
            </div>
        </div>
        <br/>
        <div class="row">
            <div class="col-4 text-right">รหัสลูกค้า</div>
            <div class="col-6">
                <multiselect
                        v-model="customer"
                        placeholder="เลือกลูกค้า"
                        :options="customers"
                        label="store_name"
                        :show-labels="false"
                        track-by="id">
                </multiselect>
            </div>
        </div>
        <br/>
        <div class="row">
            <div class="col-4 text-right">ยอดเงิน</div>
            <div class="col-4">
                <input class="form-control" v-model="credit"/>
            </div>
            <div class="col-2 text-left">บาท</div>
        </div>
        <br/>
        <div class="col text-center">
            <button type="button" class="btn btn-success" @click="saveCreditCustomer">
                <icon name="save"></icon>
                บันทึก
            </button>
            &nbsp;&nbsp;
            <button type="button" class="btn btn-outline-secondary" @click="cancelSubmit">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
        <!--<pre class="alert-warning">{{customers}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";

    export default {
        name: "save-credit-customer",
        components :{Multiselect},
        data(){
          return{
              customer : null,
              credit : "",
          }
        },
        computed:{
            ...mapState({
                form:state=>{
                    return state.InvoicePayoff.form;
                },
                customers : state =>{
                    return state.Seller.customer_sale;
                }
            })
        },
        methods:{
            saveCreditCustomer(){
                if(!this.customer){
                    alert("กรุณาเลือกลูกค้า");
                }
                else if(!this.credit || this.credit < 0){
                    alert("กรุณาใส่จำนวนเงินเครดิต");
                }
                else{
                    let data ={
                        customer_id : this.customer.id,
                        credit : this.credit,
                    };
                    this.$emit("submit",data);
                }
            },
            cancelSubmit(){
                this.$emit("submit",false);
            }
        }
    }
</script>

<style scoped>

</style>